export const TREE_METADATA_KEYS = [
  'cod_planejamento',
  'id',
  'planejamento',
  'tipo',
  'nivel_superior',
  'contador',
  'conta_dominio',
  'subtipo',
  'analiticos_ativos'
];

const normalizar = (valor) => String(valor ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase();

const ehFilho = (chave, valor) => (
  !TREE_METADATA_KEYS.includes(chave) && typeof valor === 'object' && valor !== null
);

const lerAnaliticos = (valor) => {
  if (typeof valor !== 'string') return [];
  try {
    const lista = JSON.parse(valor);
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
};

// Devolve o nó filtrado, ou null se nada nele casa. `codigo` é o mesmo que a tela usa para expandir:
// a chave na raiz, `cod_planejamento` nos demais níveis.
const filtrarNo = (no, codigo, termo, caminhos) => {
  const casaProprio = normalizar(no.planejamento).includes(termo)
    || normalizar(no.cod_planejamento ?? codigo).includes(termo);

  const resultado = {};
  let temDescendenteQueCasa = false;

  Object.entries(no).forEach(([chave, valor]) => {
    if (!ehFilho(chave, valor)) {
      resultado[chave] = valor;
      return;
    }

    // Mesmo quando o nó casa e fica inteiro, os descendentes são percorridos para abrir o caminho
    // até resultados mais fundos.
    const filho = filtrarNo(valor, valor.cod_planejamento ?? chave, termo, caminhos);
    if (filho) {
      temDescendenteQueCasa = true;
    }
    if (casaProprio) {
      resultado[chave] = valor;
    } else if (filho) {
      resultado[chave] = filho;
    }
  });

  const analiticosQueCasam = lerAnaliticos(no.analiticos_ativos).filter((analitico) => (
    analitico
    && (normalizar(analitico.descricao).includes(termo)
      || (analitico.id != null && normalizar(analitico.id).includes(termo)))
  ));

  if (analiticosQueCasam.length > 0) {
    temDescendenteQueCasa = true;
  }

  if (!casaProprio && !temDescendenteQueCasa) {
    return null;
  }

  if (temDescendenteQueCasa) {
    caminhos.add(codigo);
  }

  if (casaProprio) {
    return no;
  }

  if ('analiticos_ativos' in no) {
    resultado.analiticos_ativos = JSON.stringify(analiticosQueCasam);
  }

  return resultado;
};

/**
 * Filtra a árvore do plano de contas por código, descrição ou analítica, em todos os níveis.
 * Devolve a árvore podada e os códigos a expandir para que todo resultado fique visível.
 */
export const filtrarArvorePlanoConta = (arvore, termoBuscado) => {
  const termo = normalizar(termoBuscado).trim();
  const caminhos = new Set();

  if (!termo) {
    return { arvore, caminhos };
  }

  const resultado = {};
  Object.entries(arvore || {}).forEach(([chave, valor]) => {
    if (!ehFilho(chave, valor)) return;
    const no = filtrarNo(valor, chave, termo, caminhos);
    if (no) {
      resultado[chave] = no;
    }
  });

  return { arvore: resultado, caminhos };
};
